module.exports = __webpack_public_path__ + "img/subscribe.816f10fe.svg";